import { BundledProductsModel, getBundledProducts } from "@NA/Services/ADIBundledProductsService";
import { CustomHandlerWithResult } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    createHandlerChainRunner 
} from "@insite/client-framework/HandlerCreator";
//import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
//import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { GetBundledProductsApiParameter } from "@insite/client-framework/Types/ApiModels";
import {pushDataToDataLayer} from "@NA/Overrides/Common/Utilities/CustomTracking";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import loadRealTimeInventory from "@insite/client-framework/Store/CommonHandlers/LoadRealTimeInventory";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { createFromProduct, ProductInfo } from "@insite/client-framework/Common/ProductInfo";

interface Props extends BundledProductsModel {
    productInfos?:ProductInfo[];
    pricingLoaded?: true;
    errorMessage?: string;
}

type HandlerType = CustomHandlerWithResult<GetBundledProductsApiParameter, Props>;

export const DispatchBeginLoadBundledProducts: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchLoadBundledProducts",
        id: props.parameter.id
    });
};

export const LoadBundledProducts: HandlerType = async props => {
    const parameter = props.parameter;
    if (!parameter) {
        return false;
    }

    props.result = await getBundledProducts(parameter);

    if (!props.result) {
        return false;
    }
};

/*
export const MapProductIdsToResult: HandlerType = async props => {
    const productIds = props.result.products?.map(o => o.id);

    props.result.getProductCollectionParameter = {
        productIds: productIds
    };
};

export const LoadProductInfoList: HandlerType = props => {
    if (!props.result.getProductCollectionParameter) {
        return;
    }

    props.dispatch(
        loadProductInfoList({
            id: props.parameter.id ?? "",
            getProductCollectionParameter: props.result.getProductCollectionParameter,
        }),
    );
};
*/
export const SetUpProductInfos: HandlerType = props => {
    
    if (!props.result) {
        return;
    }

    props.result.productInfos = [];
    props.result.products?.forEach((o: any) => {
        props.result.productInfos?.push(createFromProduct(o));
    });
};
export const DispatchCompleteLoadBundledProducts: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteLoadBundledProducts",
        id: props.parameter.id,
        products: props.result.products ?? []
    });
};
export const DispatchCompleteLoadProductInfo: HandlerType = props => {
    props.dispatch({
        type: "Components/ProductInfoLists/CompleteLoadProductInfoList",
        id: props.parameter.id,
        productInfos: props.result.productInfos ?? [],
        errorMessage: props.result.errorMessage,
    });
};
export const LoadRealTimePrices: HandlerType = async props => {
    if (!props.result.productInfos || props.result.productInfos.length === 0) {
        return;
    }

    props.dispatch(
        loadRealTimePricing({
            productPriceParameters: props.result.productInfos,
            onSuccess: realTimePricing => {
                props.dispatch({
                    type: "Components/ProductInfoLists/CompleteLoadRealTimePricing",
                    id: props.parameter.id,
                    realTimePricing,
                });
                props.result.pricingLoaded = true;
            },
            onError: () => {
                props.dispatch({
                    type: "Components/ProductInfoLists/FailedLoadRealTimePricing",
                    id: props.parameter.id,
                });
                props.result.pricingLoaded = true;
            },
            onComplete(realTimePricingProps) {
                if (realTimePricingProps.apiResult) {
                    this.onSuccess?.(realTimePricingProps.apiResult);
                } else if (realTimePricingProps.error) {
                    this.onError?.(realTimePricingProps.error);
                }
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.result.pricingLoaded);
    }
};
 
export const chain = [
    DispatchBeginLoadBundledProducts,
    LoadBundledProducts,
    SetUpProductInfos,
    //MapProductIdsToResult,
    //LoadProductInfoList,
    DispatchCompleteLoadBundledProducts,
    DispatchCompleteLoadProductInfo,
    LoadRealTimePrices,
];

const loadBundledProducts = createHandlerChainRunner(chain, "LoadBundledProducts");
export default loadBundledProducts;
